// nativeDownload.js(프로토타입 패치, React 트리 밖)가 다운로드를 끝내면
// window에 'kmes:file-downloaded' 커스텀 이벤트를 쏜다. 이 컴포넌트는 그걸 받아
// 앱에서 이미 쓰고 있는 notistack 스낵바로 "다운로드됨: 파일명" + "열기" 액션을 보여준다.
// 웹에서는 nativeDownload.js가 아예 이벤트를 쏘지 않으므로(네이티브 전용) 이 컴포넌트도
// 사실상 아무 일도 하지 않는다 - App.js 최상단에 한 번만 마운트해 두면 된다.
import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';

const NativeDownloadToastBridge = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const onDownloaded = (event) => {
      const { fileName, open } = event.detail || {};
      const key = enqueueSnackbar(`다운로드됨: ${fileName || '파일'}`, {
        variant: 'success',
        autoHideDuration: 6000,
        action: (snackbarKey) => (
          <>
            {typeof open === 'function' && (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  open();
                  closeSnackbar(snackbarKey);
                }}
              >
                열기
              </Button>
            )}
          </>
        ),
      });
      return key;
    };

    window.addEventListener('kmes:file-downloaded', onDownloaded);
    return () => window.removeEventListener('kmes:file-downloaded', onDownloaded);
  }, [enqueueSnackbar, closeSnackbar]);

  return null;
};

export default NativeDownloadToastBridge;
